export default __webpack_public_path__ + "static/media/notfound.2897be7b.svg";